import { ApiConfig, HttpMethod, DynamicUrl, MICRO_SERVER_URL_CASE, MICRO_SERVER_URL_SCM } from '../constant';

const URL_CONFIGURE = `${MICRO_SERVER_URL_CASE}/meta/web-forms-configure`;
const URL_WEB_FORM_ATTACHMENT = `${MICRO_SERVER_URL_SCM}/core/attachments`;

/* web form */
export const webFormsWithPage: ApiConfig = {
  url: `${URL_CONFIGURE}`,
};

export const webFormsCreate: ApiConfig = {
  url: `${URL_CONFIGURE}`,
  method: HttpMethod.POST,
};

export const webFormsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CONFIGURE}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const webFormsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CONFIGURE}/${String(id)}`,
};

export const webFormsDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CONFIGURE}/${String(id)}`,
  method: HttpMethod.DELETE,
};

/* web form attachment */
export const webFormsAttachmentRequest: ApiConfig = {
  url: `${URL_WEB_FORM_ATTACHMENT}/request`,
  method: HttpMethod.POST,
  withCredentials: true,
  cancelPrev: false,
};

export const webFormsAttachmentCreate: ApiConfig = {
  url: URL_WEB_FORM_ATTACHMENT,
  method: HttpMethod.POST,
  withCredentials: true,
  cancelPrev: false,
};

export const webFormsAttachmentDelete: ApiConfig<DynamicUrl> = {
  url: (id) => `${URL_WEB_FORM_ATTACHMENT}/${String(id)}`,
  method: HttpMethod.DELETE,
  withCredentials: true,
  cancelPrev: false,
};
